import RequestAbstract from "./RequestAbstract";
import helper from "actions/helper";

export default class DoctorsSchedule extends RequestAbstract {
    get link() {
        return this.links.doctorSchedules;
    }

    async getSchedule(domainId, from, to) {
        const arr = [
            { field: "domainId", op: "=", value: domainId },
            { field: "beginDate", op: ">", value: helper.date.toStr(from) },
            { field: "endDate", op: "<", value: helper.date.toStr(to) },
        ];

        const req = await this.getFiltered(this.link + "/short-list", [arr], [], {
            page: 0,
            pageSize: 100000
        });
        return req;
    }

    async getScheduleForDoctor(doctorId, d, d2) {
        const arr = [
            { field: "doctorId", op: "=", value: doctorId },
            { field: "beginDate", op: ">", value: helper.date.toStr(d.setHours(0, 0)) },
            { field: "beginDate", op: "<", value: helper.date.toStr(d2.setHours(23, 59)) },
        ];

        const req = await this.getFiltered(this.link + "/short-list", [arr], [], {
            page: 0,
            pageSize: 100000
        });
        return req;
    }

    async getScheduleByParentId(parentId) {
        const arr = [
            { field: "id", op: "=", value: parentId },
        ];
        return await this.getAllFiltered([arr]);
    }

    async getShiftsByParentId(parentId) {
        const arr = [
            { field: "parentId", op: "=", value: parentId },
        ];

        const req = await this.getFiltered(this.link + "/short-list", [arr], [], {
            page: 0,
            pageSize: 100000
        });
        return req;
    }

    async getScheduleMain(domainId, from, to) {
        const dt = new Date();
        const arr = [
            { field: "domainId", op: "=", value: domainId },
            { field: "repeatType", op: "=", value: "WEEKLY" },
            { field: "beginDate", op: ">", value: helper.date.toDateServerStr(helper.date.addMonth(dt, -2)) },
        ];
        return await this.getAllFiltered([arr]);
    }

    async getScheduleForCabinet(cabinetId, d, d2) {
        const arr = [
            { field: "cabinetId", op: "=", value: cabinetId },
            { field: "beginDate", op: ">", value: helper.date.toStr(d.setHours(0, 0)) },
            { field: "beginDate", op: "<", value: helper.date.toStr(d2.setHours(23, 59)) },
        ];

        const req = await this.getFiltered(this.link + "/short-list", [arr], [], {
            page: 0,
            pageSize: 100000
        });
        return req;
    }

    async checkDocBusyOtherClinic(info) {
        const { doctorId, d1, d2, /*domainId,*/ shifts, repeatType, hourOn, hourOff, onlyTheShift, parentId } = info;

        const date1 = helper.date.setTime(new Date(d1), hourOn);
        const date2 = helper.date.setTime(new Date(d2), hourOff);
        const d1Str = helper.date.toStr(helper.date.toUtc(new Date(date1)));
        const d2Str = helper.date.toStr(helper.date.toUtc(new Date(date2)));

        // запрос любой если ошибка то блок выдает ошибку и процесс редактирования останавливается toUtc

        const resp = await this.getScheduleForDoctor(doctorId, new Date(date1), new Date(date2));
        const shedules = (resp?.data || []).filter(it => it?.parent?.id !== parentId);

        for (let items of shedules) {
            const { beginDate, endDate, domainId: domid } = items;
            let check = false;

            if (!shifts && (repeatType === "DAILY" || onlyTheShift)) { // новая смена один день или один день из регулярной
                check = helper.date.intervalsOverlapTime(beginDate, endDate, d1Str, d2Str);
            } else if (!shifts && repeatType === "WEEKLY" && !onlyTheShift) { // новая смена регулярная
                for (let i = 0; i < 4; i++) { // берем 4 недели
                    const count = 7 * i;
                    const dd1 = new Date(date1);
                    const dd2 = helper.date.setTime(new Date(dd1), hourOff);
                    const tempDate1 = helper.date.toStr(helper.date.toUtc(helper.date.addDays(dd1, count)));
                    const tempDate2 = helper.date.toStr(helper.date.toUtc(helper.date.addDays(dd2, count)));

                    check = helper.date.intervalsOverlap(beginDate, endDate, tempDate1, tempDate2);
                    if (check)
                        break;
                }
            } else if (onlyTheShift) {
                check = helper.date.intervalsOverlapTime(beginDate, endDate, d1Str, d2Str);
            } else if (shifts) { // правка смены регулярная
                for (let sh of shifts) {
                    const { beginDate: bd } = sh;
                    const dd1 = helper.date.toStr(helper.date.toUtc(helper.date.setTime(new Date(bd), hourOn)));
                    const dd2 = helper.date.toStr(helper.date.toUtc(helper.date.setTime(new Date(bd), hourOff)));

                    check = helper.date.intervalsOverlap(beginDate, endDate, dd1, dd2);

                    if (check)
                        break;
                }
            }

            if (check)
                return domid;

        }
        return false;
    }

    async checkBusyCabinet(info) {
        const { d1, d2, shifts, repeatType, hourOn, hourOff, onlyTheShift, cabinetId, parentId } = info;

        const date1 = helper.date.setTime(new Date(d1), hourOn);
        const date2 = helper.date.setTime(new Date(d2), hourOff);
        const d1Str = helper.date.toStr(helper.date.toUtc(new Date(date1)));
        const d2Str = helper.date.toStr(helper.date.toUtc(new Date(date2)));

        const resp = await this.getScheduleForCabinet(cabinetId, new Date(date1), new Date(date2));

        const shedules = (resp?.data || []).filter(it => it?.parent?.id !== parentId);
        const busyCabinets = [];

        for (let items of shedules) {
            const { beginDate, endDate } = items;
            let check = false;

            if (!shifts && (repeatType === "DAILY")) { // новая смена один день
                check = helper.date.intervalsOverlapTime(beginDate, endDate, d1Str, d2Str);
                if (check)
                    busyCabinets.push({ beginDate, endDate });
            } else if (!shifts && repeatType === "WEEKLY" && !onlyTheShift) { // новая смена регулярная
                for (let i = 0; i < 5; i++) { // берем 4 недели
                    const count = 7 * i;
                    const dd1 = new Date(date1);
                    const dd2 = helper.date.setTime(new Date(dd1), hourOff);
                    const tempDate1 = helper.date.toStr(helper.date.toUtc(helper.date.addDays(dd1, count)));
                    const tempDate2 = helper.date.toStr(helper.date.toUtc(helper.date.addDays(dd2, count)));

                    check = helper.date.intervalsOverlap(beginDate, endDate, tempDate1, tempDate2);
                    if (check) {
                        busyCabinets.push({ beginDate, endDate });
                    }
                }
            } else if (onlyTheShift) {
                check = helper.date.intervalsOverlapTime(beginDate, endDate, d1Str, d2Str);
                if (check)
                    busyCabinets.push({ beginDate, endDate });
            } else if (shifts) { // правка смены регулярная
                for (let sh of shifts) {
                    const { beginDate: bd } = sh;
                    const dd1 = helper.date.toStr(helper.date.toUtc(helper.date.setTime(new Date(bd), hourOn)));
                    const dd2 = helper.date.toStr(helper.date.toUtc(helper.date.setTime(new Date(bd), hourOff)));

                    check = helper.date.intervalsOverlap(beginDate, endDate, dd1, dd2);
                    if (check)
                        busyCabinets.push({ beginDate, endDate });
                }
            }
        }

        if (busyCabinets.length > 0)
            return busyCabinets;

        return false;
    }
}
